<template>
    <ul class="list-group">
        <li class="list-group-item tarief">
            <div class="row">
                <div class="col-12">
                    <div class="tarief-intro">
                        <span>Totale omzet (100%)</span>
                    </div>
                </div>
                <div class="col-12 text-right">
                    <div class="tarief-prijs">
                        <span class="alt"
                            >&euro; {{ formatCurrency(totalRevenues) }}</span
                        >
                    </div>
                </div>
            </div>
        </li>
        <li class="list-group-item flex-column align-items-start">
            <RockOverviewRateDetail
                v-for="(item, key) in items"
                :key="key"
                :nr="key + 1"
                :is-last="key + 1 === items.length"
                :amount="item.rate"
                :hours="item.hours"
                :bonus="selectedMonthBonus"
                :editable="editable"
                @save="(params) => save(params)"
            />
        </li>
    </ul>
</template>
<script>
import RockOverviewRateDetail from '@/components/RockOverviewRateDetail';
import RockCurrencyMixin from '@/mixins/RockCurrencyMixin.js';
import EventBus from '@/shared/VueEvent';

export default {
    components: {
        RockOverviewRateDetail
    },
    mixins: [RockCurrencyMixin],
    props: ['selectedMonthBonus', 'editable'],
    data() {
        return {
            items: [],
            updatedRevenues: 0
        };
    },
    computed: {
        totalRevenues: function () {
            return this.updatedRevenues || this.selectedMonthBonus.revenues;
        }
    },
    created() {
        const _this = this;
        EventBus.listen('addRate', () => {
            _this.items.push({
                rate: 0,
                hours: 0
            });
        });
        EventBus.listen('deleteRate', (nr) => {
            _this.items.splice(nr - 1, 1);
        });
    },
    mounted() {
        this.items = [];
        if (this.selectedMonthBonus) {
            for (const revenueDetail of this.selectedMonthBonus
                .revenuesDetails) {
                this.items.push({
                    rate: revenueDetail.rate,
                    hours: revenueDetail.hours
                });
            }
        }
    },
    methods: {
        save: function (params) {
            for (const key in this.items) {
                const item = this.items[key];
                if (Number(key) + 1 === params.nr) {
                    item.rate = params.data.amount;
                    item.hours = params.data.hours;
                }
            }
            this.updatedRevenues = this.getUpdatedRevenues().revenues;
            this.$emit('save');
        },
        getUpdatedRevenues: function () {
            const updated = {
                revenues: 0,
                revenuesDetails: []
            };
            for (const item of this.items) {
                updated.revenuesDetails.push({
                    rate: item.rate,
                    hours: item.hours
                });
                updated.revenues += item.rate * item.hours;
            }
            return updated;
        }
    }
};
</script>
